module.exports = __webpack_public_path__ + "media/images/emoticons/spade-de3fbc6f548a74aaf400dd95bfaaa283.gif";